"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GraphicType;
(function (GraphicType) {
    GraphicType["Bat"] = "Bat";
    GraphicType["Cumbia"] = "Cumbia";
    GraphicType["Deer"] = "Deer";
    GraphicType["Diamond"] = "Diamond";
    GraphicType["Hola"] = "Hola";
    GraphicType["Pizza"] = "Pizza";
    GraphicType["Resist"] = "Resist";
    GraphicType["Selena"] = "Selena";
    GraphicType["Bear"] = "Bear";
    GraphicType["SkullOutline"] = "SkullOutline";
    GraphicType["Skull"] = "Skull";
})(GraphicType || (GraphicType = {}));
exports.default = GraphicType;
